import React from 'react'
import {Box, Button, Link, Stack, Typography} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {StarOutline} from "@mui/icons-material";
import {useServiceFavorite} from "./hook/useServiceFavorite";
import {removeHtml, truncateStr} from "../Service";
import {useNavigate} from "react-router-dom";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {usePoliceMode} from "../policeMode/hook/usePoliceMode";
import {useUserInfo} from "../userInfo/hooks/useUserInfo";
import toast from 'react-hot-toast';

const ServiceItemUser = props => {
    const {profil} = useUserInfo();

    const {id, title, description, variant, image, variantName, controls, treading, treadingBadge, isFavorite, wishlistId, wishListProductId} = props

    const {addToFavorite, removeFromFavorite} = useServiceFavorite();

    const [idWhistListProduct, setIdWhistListProduct] = React.useState(wishListProductId);

    const nav = useNavigate();

    const {police} = usePoliceMode();

    const [favorite, setFavorite] = React.useState(isFavorite);
    const navigate = () => {
        if (profil.address === "") {
            toast(
                t => (
                    <Stack width={'100%'} alignItems={'center'} justifyContent={'center'}>
                        <Typography textAlign={'center'} marginBottom={'15px'}>
                            Veuillez compléter votre <b>adresse</b> dans votre profil pour pouvoir passer une commande.
                        </Typography>
                        <Button
                            width={'200px'}
                            variant="contained"
                            onClick={() => {
                                toast.dismiss(t.id);
                                nav('/profile');
                            }}>
                            Ouvrir mon profil
                        </Button>
                    </Stack>
                ),
                {
                    icon: '❌',
                    duration: 10000,
                    style: {
                        width: '600px', // Largeur augmentée
                        maxWidth: '90%', // Pour s'assurer qu'il s'adapte aux petits écrans
                    },
                },
            );
            return false;
        }
        if (controls.includes('marketplace')) {
            nav(`/item-detail/${id}`);
        } else {
            if (variant === "advice") {
                nav(`/advice/${id}`)
            } else {
                nav(`/service/${variant}/${id}`)
            }
        }
    }

    const {mode} = useDarkMode();

    return <Box className="service-item-container">
        <Box
            className="service-item-user"
            data-variant={variant}
            data-treading={treading && treadingBadge ? 'yes':'no'}
            style={{backgroundColor: mode.settings.cardBackgroundColor}}
            sx={{
                ml: {xs : 'auto' , md : 'auto', lg : '0px'},
                mr: {xs : 'auto' , md : 'auto', lg : '0px'},
            }}
        >
            <Box className="service-item__head" sx={{color : mode.settings.textColor6}}>
                <Stack direction={'row'} alignItems={'center'}>
                    <img src={`/assets/icon/${variant}.png`} alt="service" className="service-item__icon_user"/>
                    <Typography variant="subtitle5" component="span">
                        {(variantName+'').charAt(0).toUpperCase() + (variantName+'').substring(1)}
                    </Typography>
                </Stack>
                {
                    controls.includes('add-to-fav') && favorite &&
                    <Button className="remove-from-favorites" onClick={() => {
                        const done = removeFromFavorite(id, idWhistListProduct) ;
                        if (done) {
                            setFavorite(false);
                        }
                    }} >
                        <StarIcon role={'img'} aria-label="Enlever des favoris" style={{fontSize : '15px', marginRight : '4px'}}/>
                        <Typography variant={'subtitle15'}>Enlever des favoris</Typography>
                    </Button>
                }
                {
                    controls.includes('add-to-fav') && !favorite &&
                    <Button className="add-to-favorites" onClick={ async () => {
                        const resId = await addToFavorite(id, wishlistId);
                        if (resId) {
                            setFavorite(true);
                            setIdWhistListProduct(resId);
                        }
                    }
                    }>
                        <StarOutline role={'img'} aria-label="Ajouter dans mes favoris" style={{fontSize : '15px', marginRight : '4px'}}/>
                        <Typography variant={'subtitle15'}>Ajouter aux favoris</Typography>
                    </Button>
                }
            </Box>
            <Box className="service-item__image">
                <Box sx={{
                    backgroundImage: `url(${image})`,
                    backgroundSize: "cover",
                    width: "100%",
                    borderRadius: "5px",
                    minHeight: "220px"
                }} />
                <a href={`/service/${id}`} className="service-item__img-link" onClick={ e => {
                    e.preventDefault()
                    navigate();
                } } />
            </Box>
            <Box className="service-item__body">
                <Typography  variant="subtitle1" className="service-item__title" color={mode.settings.textColor}> { truncateStr(title,  police.normalMode ? 26 : 22) }</Typography>
            </Box>
            {
                controls.includes('show-detail') &&
                <Button className="btn btn-see-detail" onClick={ () => navigate() }>
                    <RemoveRedEyeIcon role={'img'} aria-label="Voir le détail du service" />
                    <Typography component="span">Voir le détail</Typography>
                </Button>
            }
        </Box>
    </Box>
}

ServiceItemUser.defaultProps = {
    controls: ['add-to-fav', 'show-detail'],
    treadingBadge: false
}

export default ServiceItemUser
